import { render, staticRenderFns } from "./CustomerTagChips.vue?vue&type=template&id=2daeebeb&scoped=true&"
import script from "./CustomerTagChips.vue?vue&type=script&lang=js&"
export * from "./CustomerTagChips.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTagChips.vue?vue&type=style&index=0&id=2daeebeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daeebeb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
